import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from "@angular/forms";

import { environment } from 'src/environments/environment';
import { User } from 'src/app/model/user';
import { MenuService } from 'src/app/service/MenuService';
import { TranslateService } from '@ngx-translate/core';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { UserRole } from 'src/app/model/userRole';
import { CommonService } from 'src/app/service/CommonService';
import { ContactUsService } from 'src/app/service/ContactUsService';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('oamLoginForm') oamLoginFormElement: ElementRef;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  oamSubmitUri = environment.getOamServerUri();

  certificateUrl;
  showPassword: boolean = false;
  submitted = false;
  errorCode = "";
  errorMsgKey = "";
  notMatch = false;

  currentLanguage: string;
  languageChangeSubs: Subscription;
  dataSubscription: Subscription;
  notifications:any[];
  notificationsLength = 0;

  constructor(
    public fb: FormBuilder,
    public route: ActivatedRoute,
    public router: Router,
    public rest: CommonService,
    public translate: TranslateService,
    public menuService: MenuService,
    public commonService: CommonService,
    public contactService: ContactUsService) {
    menuService.setDisplayStatusByMenuType('login');
  }

  loginForm = this.fb.group({
    username: ['', [Validators.required, BpsEmailValidator.restricted]],
    password: ['', [Validators.required]],
    bmctx: [''],
    request_id: ['']
  });

  ngOnInit(): void {
    //sessionStorage.clear(); 
    //only remove user, but to keep currentLang
    sessionStorage.removeItem("user");

    this.currentLanguage = this.translate.currentLang;
    this.subscribeToLanguageChange();
    this.dataSubscription = this.rest.getNotifications().subscribe((data:any)=>{
      this.notifications = data.notifications;
      this.notificationsLength = data.notifications.length;
    });    

    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.errorCode = (params['p_error_code'])?.trim() ?? '';
        const endUrl = (params['end_url'])?.trim() ?? '';
        const fullResourceUrl = (params['resource_url'])?.trim() ?? '';
        const clientID = (params['client_id'])?.trim() ?? '';
        let resourceUrl: string = null;

        // if resource url received then search of the resource_url within this string
        resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
        resourceUrl = this.mapResourceURL(resourceUrl);
        
        // Inject Resource URL validation logic here 
        // If signinURL is malformed
        //const urlPattern = /^(https?):\/\/[^\s/$.?#<>].[^\s<>]*$/i;

        if (resourceUrl) {
          const isEncodedURL = resourceUrl !== decodeURIComponent(resourceUrl);

          //if (resourceUrl.includes('%')) {
          if (isEncodedURL) {
            resourceUrl = decodeURIComponent(resourceUrl);
          }
        }
        if (!this.validateLoginURL(window.location.href)) // || !this.validateLoginURL(resourceUrl))
        {
          //const urlPattern = /^(https?):\/\/[^\s<>].[^\s<>]*$/i;
          console.log('window.location.href:: ' + window.location.href);
          console.log('Entered resourceUrl:: ' + resourceUrl);

          //if (resourceUrl && !urlPattern.test(resourceUrl)) {
          console.log('Malformed URL encountered ');
          this.router.navigate(['public/error']);
          return;
        }

        if (!resourceUrl.includes('/opsbpssecure/secure')) {
          this.contactService.setDisplayStatusByPageType('login');
        } else {
          this.contactService.setDisplayStatusByPageType('opsbps');
        }

        const bmctx = (params['bmctx'])?.trim() ?? '';
        const reqid = (params['request_id'])?.trim() ?? '';
        console.log("errorCode: [" + this.errorCode + "], reqid: [" + reqid + "], bmctx: [" + bmctx + "]");

        this.notMatch = this.errorCode.length > 0;
        if (this.notMatch) {
          this.prepareErrorMessageKey();
        }

        const lang = (params['lang'])?.trim().toLowerCase() ?? '';
        if (lang === 'en' || lang === 'fr') {
          sessionStorage.setItem('currentLang', lang);
          this.translate.use(lang);
        } else {
          var currentLang = sessionStorage.getItem('currentLang');
          currentLang = (currentLang === 'en' || currentLang === 'fr') ? currentLang : 'en';
          this.translate.use(currentLang);
        }  

        this.certificateUrl = (endUrl === '') ? resourceUrl : endUrl;
        this.certificateUrl = (this.certificateUrl === '') ? sessionStorage.getItem("resource_url") : this.certificateUrl;
        this.loginForm.get("bmctx").setValue(bmctx);
        this.loginForm.get("request_id").setValue(reqid);

        sessionStorage.setItem("resource_url", this.certificateUrl);

        //the reqeust_id is mandatory here
        //if there's no request_id, it will be considered as unsolicited login
        //in this case, even you can login with correct credentils, you will still get an error page
        //so we just redirect user to /secure/profile, and let OAM catch(protect) it
        //then OAM will redirect user to /public/login with a request_id
        if (environment.env !== "local" && reqid.length == 0) {
          //window.location.href = "/opsbpssecure/secure/profile?ts=" + Date.now();
          window.location.href = "/opsbpssecure/secure/myservices?ts=" + Date.now();
          return;
        }
      }
      );

    // Testing in local - do not remove
    this.setLocalUser();

  }

  private subscribeToLanguageChange(): void {
    this.languageChangeSubs = this.translate.onLangChange.subscribe(
      () => {
        this.currentLanguage = this.translate.currentLang;
      }
    );
  }

  validateLoginURL(url: string): boolean {
    const restrictedCharacters = /<|>|\(|\)|script|function|alert/gi;
    return !restrictedCharacters.test(url);
  }

  setLocalUser(): void {
    if (environment.env === "local") {
      let user = new User();
      user.email = "p1@ontario.ca";
      user.displayName = "David Li";
      user.firstName = "David";
      user.lastName = "Li";
      user.preferredLanguage = "en";
      user.pkiuser = "false";
      user.guid = "1234-324sdf-234sd023-sdfsd34";
      user.emailAccess = true;
      user.isRoleAdmin = true;
      user.emailVerified = "true";
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("currentLang", user.preferredLanguage);

      let userRoleDetails: UserRoleDetails = new UserRoleDetails();
      userRoleDetails.user = user;
      let userRole: UserRole = new UserRole();
      userRole.roleName = "TEST";
      userRoleDetails.role = userRole;
      sessionStorage.setItem("selectedUserRole", JSON.stringify(userRoleDetails));
    }
  }

  prepareErrorMessageKey() {
    console.log("prepareErrorMessageKey.errorCode: " + this.errorCode.toLowerCase());
    this.errorMsgKey = 'bss.login.err.' + this.errorCode.toLowerCase();

    //check if user is pkiUser
    if (this.errorCode.toLowerCase() !== 'use-pki') {
      const loginEmail = sessionStorage.getItem("loginEmail");
      console.log("sessionStorage.loginEmail: " + loginEmail);

      if (loginEmail) {
        this.commonService.checkPkiUser(loginEmail, (result) => {
          if (result) {
            console.log("checkPki found true");
            this.errorMsgKey = 'bss.login.err.use-pki';
          }
        });
      }
    }

    console.log("prepareErrorMessageKey.errorMsgKey: [" + this.errorMsgKey + "]");

    // let errMessage = this.translate.instant(this.errorMsgKey);
    // if (errMessage === this.errorMsgKey) {
    //   this.errorMsgKey = 'bss.login.err.sorryNotMatch';
    // }
  }

  //Handle browser Back/Forward button, clear the value before window unload 
  @HostListener('window:beforeunload', ['$event'])
  @HostListener('window:unload', ['$event'])
  handleWindowClose(event: Event) {
    this.loginForm.disable();
    this.loginForm.reset();
  }

  ngOnDestroy(): void { 
    this.loginForm.disable();
    this.loginForm.reset();

    if(this.languageChangeSubs){
      this.languageChangeSubs.unsubscribe();
    }    

    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    if (this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  onCertificateLogin() {
    const redirectUrl = environment.getOamCertificateUri() + "?end_url=" + this.certificateUrl;
    window.location.href = redirectUrl;
  }

  onRegister() {
    this.router.navigate(['/public/register']);
  }

  onForgotPassword() {
    this.router.navigate(['/public/forgotpassword']);
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.valid) {
      sessionStorage.setItem("loginEmail", this.loginForm.get("username").value);
      this.oamLoginFormElement.nativeElement.submit();
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  // make an api call to retrieve the mfa url
  mapResourceURL(signinURL: string) :string {
    if (signinURL) {
      signinURL = decodeURIComponent(signinURL);
      this.commonService.getURL(signinURL).subscribe(response => {
        console.log("get-sigin-url:" + JSON.stringify(response));
        if (response.result == 1) {
          return null;
        } else {
          let resourceUrl = response.usermfaURL;
          sessionStorage.setItem("resource_url", resourceUrl);
          return resourceUrl;
        }
      });
    }
    return signinURL;
  }

}